<template>
    <modal title="Update Exchange" :size="'xl'" @close="$emit('close')">
        <template #content>
            <load-area v-if="data==null"></load-area>
            <pre v-if="data!=null" class="m-0">{{data}}</pre>
        </template>
    </modal>
</template>

<script>
    export default {
        name:"detail",
        props:{
            id:Number
        },
        data(){
            return {
                data:null
            }
        },
        created(){
            this.$appAxiosAdmin.get(`Operators/UpdateExchange/`+this.id).then(response => {
                this.data=response.data;
            }).catch(err=>{
                this.data=err;
            });
        }
    }
</script>

<style>

</style>